// extracted by mini-css-extract-plugin
export default {"root":"styles_root__uibcW","edit-overlay":"styles_edit-overlay__2xwG7","editOverlay":"styles_edit-overlay__2xwG7"};